export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0066.26bc1bb0.webp";